import { DatePart } from "@mcleod/core";
import { AutogenLayoutCustomerOrderCountReport } from "./autogen/AutogenLayoutCustomerOrderCountReport";

export class CustomerOrderCountReport extends AutogenLayoutCustomerOrderCountReport {
    override onLoad(): void | Promise<void> {
        this.textboxDateType.selectedItem = this.textboxDateType.items[1];
        this.setIntervalMaxValue();
    }

    onChangeDate() {
        this.setIntervalMaxValue();
        this.textboxInterval?.validateSimple(true, true);
    }

    private setIntervalMaxValue() {
        if (this.textboxInterval != null) {
            const range = this.textboxDateRange.getDateRange();
            this.textboxInterval.maxValue = range.getDifferenceInDates(DatePart.DAY);
        }
    }
}
